import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import PublicEventsCalendar from "./PublicEventsCalendar.jsx";

{ /*
  Filename:    ClientHelp.js
  Description: This page allows clients to view upcoming community events.
*/ }

const ClientHelp = () => {
  useEffect(() => { // Code to run only on first page load
    window.scrollTo(0, 0); // scroll to top of page
  }, []);

  let newDate = new Date();
  let year = newDate.getFullYear();

  return (
    <React.Fragment>
      {/* navbar */}
      <nav className="nav navbar navbar-expand-xl navbar-light iq-navbar">
        <div className="container-fluid navbar-inner">
          <a href="/" className="navbar-brand">
            <div className="logo-main">
              <div className="logo-normal">
                <img src={
                  localStorage.getItem("BurchCoin") === JSON.stringify(true)
                    ? './images/Burchcoin.png'
                    : './images/BridgingHopeNoWord.svg'
                } className="img-fluid" alt="logo" style={{ maxHeight: "45px" }} />
              </div>
              <div className="logo-mini">
                <svg className="text-primary icon-30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="-0.757324" y="19.2427" width="28" height="4" rx="2" transform="rotate(-45 -0.757324 19.2427)" fill="currentColor"></rect>
                  <rect x="7.72803" y="27.728" width="28" height="4" rx="2" transform="rotate(-45 7.72803 27.728)" fill="currentColor"></rect>
                  <rect x="10.5366" y="16.3945" width="16" height="4" rx="2" transform="rotate(45 10.5366 16.3945)" fill="currentColor"></rect>
                  <rect x="10.5562" y="-0.556152" width="28" height="4" rx="2" transform="rotate(45 10.5562 -0.556152)" fill="currentColor"></rect>
                </svg>
              </div>
            </div>
            <h4 className="logo-title">Bridging Hope</h4>
          </a>
        </div>
      </nav>

      {/* body */}
      <div className="col-12">
        <h1 className="text-center my-3">Community Events</h1>

        <PublicEventsCalendar />

        <Link to="/" className="btn btn-secondary col-4 offset-4 my-5">Back to home page</Link>

        {/* footer */}
        <footer className="footer">
          <div className="footer-body d-flex justify-content-between mx-4 pb-3">
            <ul className="list-inline mb-0 p-0">
              <li className="list-inline-item"><a href="./dashboard/extra/privacy-policy.html">Privacy Policy</a></li>
              <li className="list-inline-item"><a href="./dashboard/extra/terms-of-service.html">Terms of Use</a></li>
            </ul>
            <div className="right-panel">
              <p>© {year} Bridging Hope. All Rights Reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
}

export default ClientHelp;
